import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

import useCart from "hooks/useCart";

import { getCartPrice, getCurrentDiscount } from "../utils";
import { formatPriceCents, getModelType, getModelName } from "components/product/utils";
import CouponForm from "../../couponForm";
import { getCartEligibility } from "components/localOfferEligibility/LocalOfferEligibility";
import LocalOfferPicto from "components/localOffer/assets/localOfferPicto.svg";
import { SHIPPING_OPTIONS } from "../constants";

export default function FunnelSummaryCard({ initialCart }) {
  const classes = useStyle();
  const [contextCart] = useCart();
  const [isEligibleToLocalOffer, setIsEligibleToLocalOffer] = React.useState(false);
  // needed for paiement step when we reset cart
  const cart = contextCart || initialCart;

  // Check if client is eligible to the local offer by checking for every product of his cart

  React.useEffect(() => {
    setIsEligibleToLocalOffer(getCartEligibility(cart));
  }, [cart]);

  const shippingCosts = cart.shipping.price;
  const shippingType = cart.shipping.delivery_option_type;
  const couponDiscount = cart.coupon.discount_raw_amount;
  return (
    <div className={classes.container}>
      {cart.selection.map(({ product, warranty_pk, warranty_price, warranty_years }) => {
        const modelName = getModelName(product);
        return (
          <div key={modelName} className={classes.product}>
            <div className={classes.productInfos}>
              <div>
                <Typography className={classes.semiBold}>{product.brand}</Typography>
                <Typography variant="body2" className={classes.semiBold}>
                  {getModelType(product)}
                </Typography>
                <Typography variant="body2" className={classes.semiBold}>
                  {product.model_reference}
                </Typography>
              </div>
              <Typography variant="caption" className={classes.price}>
                {formatPriceCents(product.price)}
              </Typography>
            </div>
            {cart.selection.length === 1 ? <div className={classes.divider} /> : <div className={classes.spacer} />}
            {warranty_pk && (
              <div className={classes.inline}>
                <div className={classes.yellowBullet} />
                <Typography variant="body2" className={classes.bulletText}>
                  {`Garantie ${warranty_years} an${warranty_years > 1 ? "s" : ""}`}
                </Typography>
                <Typography variant="caption" className={classes.price}>
                  {warranty_price > 0 ? formatPriceCents(warranty_price) : "Offerte"}
                </Typography>
              </div>
            )}
            {cart.selection.length > 1 && <div className={classes.divider} />}
          </div>
        );
      })}
      {shippingCosts !== undefined && (
        <div className={classes.inline}>
          <div className={classes.greenBullet} />
          <Typography variant="body2" className={classes.bulletText}>
            {SHIPPING_OPTIONS.find((opt) => opt.type === shippingType)?.summaryText || "Frais de livraison"}
          </Typography>

          <Typography variant="caption" className={classes.price}>
            {shippingCosts > 0 ? formatPriceCents(shippingCosts) : "Offert"}
          </Typography>
        </div>
      )}
      {couponDiscount > 0 && (
        <div className={classes.inline}>
          <div className={classes.pinkBullet} />
          <Typography variant="body2" className={classes.bulletText}>
            Code promo
          </Typography>
          <Typography variant="caption" className={classes.price}>
            {`-${formatPriceCents(getCurrentDiscount(cart))}`}
          </Typography>
        </div>
      )}
      <CouponForm />
      <div className={classes.divider} />
      <div className={classes.inline}>
        <Typography variant="body2" className={classes.semiBold}>
          Total du panier
        </Typography>
        <Typography className={classes.priceTotal}>{formatPriceCents(getCartPrice(cart))}</Typography>
      </div>
      {isEligibleToLocalOffer && (
        <Box display={"flex"} mt={4}>
          <Box pr={1}>
            <LocalOfferPicto className={classes.localOfferPicto} />
          </Box>
          <Box>
            <Typography variant="body1" color="secondary" style={{ fontSize: 18, fontWeight: 500 }}>
              Click & Collect gratuit ou livraison 48h !
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  spacer: {
    marginTop: theme.spacing(),
  },
  productInfos: {
    display: "grid",
    gridTemplateColumns: "1fr min-content",
    gridColumnGap: theme.spacing(),
  },
  yellowBullet: {
    width: 6,
    height: 6,
    backgroundColor: theme.palette.yellow,
    borderRadius: 50,
  },
  greenBullet: {
    width: 6,
    height: 6,
    backgroundColor: theme.palette.green,
    borderRadius: 50,
  },
  pinkBullet: {
    width: 6,
    height: 6,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 50,
  },
  bulletText: {
    marginRight: "auto",
    marginLeft: theme.spacing(),
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  priceTotal: {
    fontSize: 20,
    fontWeight: 500,
  },
  price: {
    fontSize: 15,
  },
  semiBold: {
    fontWeight: 500,
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: "#DBDFE8",
    height: 1,
    width: "100%",
  },
  inline: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    justifyContent: "space-between",
  },
}));
